import { Store } from 'react-notifications-component';

    const addNotification = (notifTitle, message) => {
        Store.addNotification({
            title: notifTitle,
            message: message,
            type: "success",
            insert: "top",
            container: "top-center",
            animationIn: ["animate__animated", "animate__fadeIn"],
            animationOut: ["animate__animated", "animate__fadeOut"],
            dismiss: {
            duration: 3000,
            onScreen: true
            }
        }); 
    }

export {addNotification};

